<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <tabs-comp :tabs="tabs" />
            <v-alert v-if="loadError" type="error" dense outlined>{{ lang.whatsapp_request_failed }}</v-alert>
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
                <v-col cols="12" v-for="tpl in templates" :key="tpl.key" style="margin-bottom:14px;">
                    <div style="border:1px solid #555;border-radius:10px;padding:14px;">
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                            <label style="font-weight:bold;font-size:1.05rem;">{{ tpl.label }}</label>
                            <div style="display:flex;align-items:center;">
                                <span v-if="savedKey === tpl.key" style="color:#0a8a3f;font-size:0.9rem;margin-inline-end:10px;">{{ lang.saved || 'تم الحفظ' }}</span>
                                <template v-if="tpl.toggleable">
                                    <span style="font-size:0.85rem;color:#666;margin-inline-end:6px;">{{ tpl.enabled ? (lang.enabled || 'مفعّل') : (lang.disabled || 'معطّل') }}</span>
                                    <b-form-checkbox
                                        v-model="tpl.enabled"
                                        :disabled="!!busyKeys[tpl.key]"
                                        switch
                                        @change="toggleEnabled(tpl)"
                                    ></b-form-checkbox>
                                </template>
                            </div>
                        </div>

                        <b-form-textarea
                            v-if="tpl.placeholders.length"
                            v-model="tpl.value"
                            @input="savedKey = ''"
                            :ref="'ta_'+tpl.key"
                            class="inborder"
                            rows="3"
                            max-rows="20"
                        ></b-form-textarea>
                        <b-form-select
                            v-else-if="tpl.input === 'hour'"
                            v-model="tpl.value"
                            @input="savedKey = ''"
                            :options="hours"
                            class="inborder"
                        ></b-form-select>
                        <b-form-input
                            v-else
                            v-model="tpl.value"
                            @input="savedKey = ''"
                            class="inborder"
                        ></b-form-input>

                        <div v-if="tpl.hint" style="margin-top:6px;font-size:0.85rem;color:#666;">{{ tpl.hint }}</div>

                        <div v-if="tpl.placeholders.length" style="margin-top:8px;">
                            <span style="font-size:0.85rem;color:#666;margin-inline-end:6px;">{{ lang.available_variables || 'المتغيرات المتاحة:' }}</span>
                            <b-button
                                v-for="ph in tpl.placeholders"
                                :key="ph"
                                size="sm"
                                variant="outline-secondary"
                                style="margin:2px;font-size:0.8rem;padding:2px 8px;"
                                @click="insertPlaceholder(tpl, ph)"
                            >{{ phLabel(ph) }}</b-button>
                        </div>

                        <div style="text-align:end;margin-top:8px;">
                            <b-button variant="light" style="background:blue;color:#fff;width:120px;" :disabled="!!busyKeys[tpl.key]" @click="save(tpl)">{{ lang.save || 'حفظ' }}</b-button>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
export default{
    components: {
        HeaderPortrate, Footer,
        TabsComp,
    },
    data() {
        return {
            templates: [],
            savedKey: '',
            loading: false, loadError: false, busyKeys: {},
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        hours: function(){
            const t = [];
            for(let h = 0; h < 24; h++){
                t.push({ value: String(h), text: (h < 10 ? '0' : '') + h + ':00' });
            }
            return t;
        },
        tabs: function(){

            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                      if(alicense[value.perms[0]] || value.perms[0] == 'any')
                          t.push(value)
                    }
                }
            })

            return t;
        },
    },
    methods: {
        phLabel(ph){
            return '{{' + ph + '}}';
        },
        insertPlaceholder(tpl, ph){
            tpl.value = (tpl.value || '') + this.phLabel(ph);
        },
        async templateRequest(type, fields = {}){
            const post = new FormData();
            post.append('type', type);
            post.append('lang',this.lang.langname || 'ar');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            for (const [key,value] of Object.entries(fields)) post.append('data['+key+']',value);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path,post);
            const payload = response && response.data;
            if (!payload || Number(payload.error && payload.error.number)!==200 || !payload.results) throw new Error('Request failed');
            return payload.results.data;
        },
        async getTemplates(){
            this.loading=true;this.loadError=false;
            try {
                const rows=await this.templateRequest('getWahaTemplates');
                if (!Array.isArray(rows)) throw new Error('Invalid templates');
                this.templates=rows.filter(row=>row && typeof row.key==='string' && Array.isArray(row.placeholders));
                return true;
            } catch(e) {this.loadError=true;return false;} finally {this.loading=false;}
        },
        async toggleEnabled(tpl){
            if(this.busyKeys[tpl.key]) return false;
            this.$set(this.busyKeys,tpl.key,true);this.loadError=false;
            const requested=!!tpl.enabled;
            try {
                const saved=await this.templateRequest('toggleWahaTemplateEnabled',{key:tpl.key,enabled:requested?1:0});
                if (!saved || !['0','1'].includes(saved.value)) throw new Error('Invalid toggle');
                tpl.enabled=saved.value==='1';return true;
            } catch(e) {tpl.enabled=!requested;this.loadError=true;return false;}
            finally {this.$delete(this.busyKeys,tpl.key);}
        },
        async save(tpl){
            if(this.busyKeys[tpl.key]) return false;
            this.$set(this.busyKeys,tpl.key,true);this.loadError=false;this.savedKey='';
            try {
                const saved=await this.templateRequest('saveWahaTemplate',{key:tpl.key,value:tpl.value || ''});
                if (!saved || saved.key!==tpl.key || typeof saved.value!=='string') throw new Error('Invalid save');
                tpl.value=saved.value;this.savedKey=tpl.key;return true;
            } catch(e) {this.loadError=true;return false;} finally {this.$delete(this.busyKeys,tpl.key);}
        },
    },
    created(){
        this.getTemplates()
    }

}
</script>
